// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bullet__KI8pLUlxa {\n  line-height: 1.6;\n  padding: 0.125rem 0;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Bullet/Bullet.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".bullet {\n  line-height: 1.6;\n  padding: 0.125rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export var bullet = "bullet__KI8pLUlxa";
export default ___CSS_LOADER_EXPORT___;
